
// ==============================|| OVERRIDES - MENU ITEM ||============================== //

export default function MenuItem (theme) {
	return {
		MuiMenuItem: {
			styleOverrides: {
				root: {
					// padding: '4px 8px',
					// fontSize: '0.8rem',
					// whiteSpace: 'nowrap'
				}
			}
		}
	}
}
